import { createFetchRequester } from '@algolia/requester-fetch';
import algoliasearch, { SearchClient } from 'algoliasearch';
import { ApiClient } from '../client/ApiClient';
import { AlgoliaStoreData } from './types/AlgoliaStoreData';

export type StoreClientConstructorArgs = {
  algoliaAppId: string;
  algoliaSearchApiKey: string;
  algoliaSearchIndex: string;
};
export class StoreClient extends ApiClient {
  private _algoliaClient: SearchClient;
  private _algoliaSearchIndex: string;

  constructor({ algoliaAppId, algoliaSearchApiKey, algoliaSearchIndex }: StoreClientConstructorArgs) {
    super();
    this._algoliaSearchIndex = algoliaSearchIndex;
    this._algoliaClient = algoliasearch(algoliaAppId, algoliaSearchApiKey, { requester: createFetchRequester() });
  }

  async getStore(locationId: string): Promise<AlgoliaStoreData> {
    const algoliaIndex = this._algoliaClient.initIndex(this._algoliaSearchIndex);

    const response = (await algoliaIndex.getObject(locationId)) as AlgoliaStoreData;

    return response;
  }

  async getStores(locationIds: Array<string>): Promise<Array<AlgoliaStoreData>> {
    const algoliaIndex = this._algoliaClient.initIndex(this._algoliaSearchIndex);

    const test = await algoliaIndex.getObjects(locationIds);

    return test.results as Array<AlgoliaStoreData>;
  }
}
